import React, { useState, useEffect } from "react";
import {
  resetServicesError,
  verifyTanAction,
  resetTanVerifyData,
} from "../../../redux/services/index";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { ServicesInput } from "../../../components/Services";
import { isTanValid } from "../../../utils/commonFunctions";
import { TanVerifyType } from "../../../redux/services/serviceTypes";
import { verifyTanType } from "../../../commonTypes/serviceTypes";
import { Loader, CommonHeader } from "../../../components/commons";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { GetPathBeforeClientCode } from "../../../components/commons/UserManagement";

type AppProps = {
  fetching: boolean;
  success: number | null;
  error: string | null;
  token: string | null;
  history: any;
  tanVerifyDetails: TanVerifyType | null;
  dispatchResetServicesErrorAction: () => void;
  dispatchVerifyTanAction: (data: verifyTanType) => void;
  dispatchResetTanVerifyData: () => void;
};

const TanVerify = ({
  success,
  fetching,
  token,
  error,
  tanVerifyDetails,
  history,
  dispatchResetServicesErrorAction,
  dispatchVerifyTanAction,
  dispatchResetTanVerifyData,
}: AppProps) => {
  const [tanNo, setTanNo] = useState<string>("");
  const [isTanVerifyPresent, setIsTanVerifyPresent] = useMenuCheck();
  const url = history?.location?.pathname;

  useEffect(() => {
    setIsTanVerifyPresent(GetPathBeforeClientCode(url), "url");
    dispatchResetServicesErrorAction();
    dispatchResetTanVerifyData();
  }, []);

  useEffect(() => {
    if (isTanVerifyPresent === false) {
      history.push("/access-denied");
    }
  }, [isTanVerifyPresent]);

  const handleTanChange = (event: any) => {
    setTanNo(event.target.value);
  };

  const handleVerifyPanInfo = () => {
    if (tanNo && token) {
      let finalData = {
        token,
        tanNo,
      };
      dispatchVerifyTanAction(finalData);
    }
  };

  return (
    <div className="pan-wrap">
      <CommonHeader title="Verify TAN Info" />
      <div className="row">
        <div className="col-4  login-leftx " style={{ borderRadius: "8px" }}>
          <ServicesInput
            handleChange={handleTanChange}
            placeholder="TAN Number"
            serviceType={tanNo}
            autoFocus
            maxLength={10}
          />
          <button
            className="btn btn-primary w-100 mt-2"
            onClick={handleVerifyPanInfo}
            disabled={tanNo?.length !== 10 || !isTanValid(tanNo)}
          >
            Submit
          </button>
        </div>
        {tanVerifyDetails ? (
          <div className="col-8">
            <table className="table table-bordered table-border-radius">
              <tbody>
                <tr>
                  <th>Full Name</th>{" "}
                  <td className="branch">{tanVerifyDetails?.nameOrgn}</td>
                </tr>
                <tr>
                  <th>Address Line 1</th>{" "}
                  <td className="micr">{tanVerifyDetails?.addLine1}</td>
                </tr>
                <tr>
                  <th>Address Line 2</th>{" "}
                  <td className="micr">{tanVerifyDetails?.addLine2}</td>
                </tr>
                <tr>
                  <th>Address Line 3</th>{" "}
                  <td className="micr">{tanVerifyDetails?.addLine3}</td>
                </tr>
                <tr>
                  <th>Address Line 5</th>{" "}
                  <td className="micr">{tanVerifyDetails?.addLine5}</td>
                </tr>
                <tr>
                  <th>PIN</th> <td className="micr">{tanVerifyDetails?.pin}</td>
                </tr>
                <tr>
                  <th>Phone Number</th>{" "}
                  <td className="micr">{tanVerifyDetails?.phoneNum}</td>
                </tr>
                <tr>
                  <th>Email</th>{" "}
                  <td className="micr">{tanVerifyDetails?.emailId1}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : error ? (
          <div className="col-8">
            <div className="card p-5 w-100">
              <h3 className="error">{!!error ? error : "No result Found!"}</h3>
            </div>
          </div>
        ) : null}
      </div>
      {fetching && <Loader />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  success: state.services.success,
  fetching: state.services.fetching,
  error: state.services.error,
  tanVerifyDetails: state.services.tanVerifyDetails,
  token: state.auth.token,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetServicesErrorAction: () => dispatch(resetServicesError()),
  dispatchVerifyTanAction: (data: verifyTanType) =>
    dispatch(verifyTanAction(data)),
  dispatchResetTanVerifyData: () => dispatch(resetTanVerifyData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TanVerify);
